import _objectSpread from "/Users/joe/Projects/onthewall-v2-leeungno/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regeneratorRuntime from "/Users/joe/Projects/onthewall-v2-leeungno/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _toConsumableArray from "/Users/joe/Projects/onthewall-v2-leeungno/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
var _marked = /*#__PURE__*/ _regeneratorRuntime().mark(syncNumberOfChat), _marked2 = /*#__PURE__*/ _regeneratorRuntime().mark(syncNumberOfObjectChat), _marked3 = /*#__PURE__*/ _regeneratorRuntime().mark(postChat), _marked4 = /*#__PURE__*/ _regeneratorRuntime().mark(deleteChat), _marked5 = /*#__PURE__*/ _regeneratorRuntime().mark(postObjectChat), _marked6 = /*#__PURE__*/ _regeneratorRuntime().mark(deleteObjectChat), _marked7 = /*#__PURE__*/ _regeneratorRuntime().mark(watchSyncNumberOfChat), _marked8 = /*#__PURE__*/ _regeneratorRuntime().mark(watchSyncNumberOfObjectChat), _marked9 = /*#__PURE__*/ _regeneratorRuntime().mark(watchPostChat), _marked10 = /*#__PURE__*/ _regeneratorRuntime().mark(watchDeleteChat), _marked11 = /*#__PURE__*/ _regeneratorRuntime().mark(watchPostObjectChat), _marked12 = /*#__PURE__*/ _regeneratorRuntime().mark(watchDeleteObjectChat), _marked13 = /*#__PURE__*/ _regeneratorRuntime().mark(chatSaga);
import { all, fork, call, put, takeEvery, take, cancel } from 'redux-saga/effects';
import { actions } from '../reducers/chat';
import { rsfDB, firestore } from '../lib/firebase'; // import { Notifier } from "../utils/notify/Notifier";
// import { sendNotifier } from "../utils/notify/NotifyPolicy";
// call은 동기, fork는 비동기 요청
function syncNumberOfChat(action) { var id, number, task; return _regeneratorRuntime().wrap(function syncNumberOfChat$(_context) { while (1)
    switch (_context.prev = _context.next) {
        case 0:
            id = action.id, number = action.number;
            _context.next = 3;
            return fork(rsfDB.syncDocument, firestore().collectionGroup('Comment').where('channelId', '==', id).where('isDeleted', '==', false).where('createdAt', '>', new Date(Date.now() - 1000 * 60 * 60 * 24)).orderBy('createdAt', 'desc').limit(number), { successActionCreator: function successActionCreator(data) { var chats = []; data.forEach(function (doc) { var _doc$data, _doc$data$createdAt; chats = [{ id: doc.id, name: doc.data().name, type: doc.data().type, value: doc.data().value, target: (_doc$data = doc.data()) === null || _doc$data === void 0 ? void 0 : _doc$data.targetId, createdAt: ((_doc$data$createdAt = doc.data().createdAt) === null || _doc$data$createdAt === void 0 ? void 0 : _doc$data$createdAt.seconds) * 1000, channelId: doc.data().channelId }].concat(_toConsumableArray(chats)); }); return { type: actions.SYNC_NUMBER_OF_CHAT_SUCCESS, data: chats }; }, failureActionCreator: function failureActionCreator(err) { return { type: actions.SYNC_NUMBER_OF_CHAT_FAILURE, err: err.message }; } });
        case 3:
            task = _context.sent;
            _context.next = 6;
            return take(actions.SYNC_NUMBER_OF_CHAT_DONE);
        case 6:
            _context.next = 8;
            return cancel(task);
        case 8:
        case "end": return _context.stop();
    } }, _marked); }
function syncNumberOfObjectChat(action) { var id, target, limit, task; return _regeneratorRuntime().wrap(function syncNumberOfObjectChat$(_context2) { while (1)
    switch (_context2.prev = _context2.next) {
        case 0:
            id = action.id, target = action.target, limit = action.limit;
            _context2.next = 3;
            return fork(rsfDB.syncDocument, firestore().collection('Channel').doc(id).collection('Object').doc(target).collection('Comment').where('isDeleted', '==', false).orderBy('createdAt', 'desc').limit(limit), { successActionCreator: function successActionCreator(data) { var chats = []; data.forEach(function (doc) { var _doc$data$createdAt2; chats.unshift({ id: doc.id, name: doc.data().name, type: doc.data().type, value: doc.data().value, createdAt: ((_doc$data$createdAt2 = doc.data().createdAt) === null || _doc$data$createdAt2 === void 0 ? void 0 : _doc$data$createdAt2.seconds) * 1000, target: target, channelId: doc.data().channelId }); }); return { type: actions.SYNC_NUMBER_OF_OBJECT_CHAT_SUCCESS, data: chats }; }, failureActionCreator: function failureActionCreator(err) { return { type: actions.SYNC_NUMBER_OF_OBJECT_CHAT_FAILURE, err: err.message }; } });
        case 3:
            task = _context2.sent;
            _context2.next = 6;
            return take(actions.SYNC_NUMBER_OF_OBJECT_CHAT_DONE);
        case 6:
            _context2.next = 8;
            return cancel(task);
        case 8:
        case "end": return _context2.stop();
    } }, _marked2); }
function postChat(action) {
    var id, data, snapshot;
    return _regeneratorRuntime().wrap(function postChat$(_context3) {
        while (1)
            switch (_context3.prev = _context3.next) {
                case 0:
                    id = action.id, data = action.data; // 댓글 입력을 진행할 경우, 유저를 저장한다.
                    _context3.next = 3;
                    return put({ type: actions.SAVE_USER, name: data.name, password: data.password });
                case 3:
                    _context3.prev = 3;
                    _context3.next = 6;
                    return call(rsfDB.addDocument, "Channel/".concat(id, "/Comment"), _objectSpread(_objectSpread({}, data), {}, { channelId: id, createdAt: firestore.FieldValue.serverTimestamp(), isDeleted: false }));
                case 6:
                    snapshot = _context3.sent;
                    _context3.next = 9;
                    return call(rsfDB.updateDocument, "Channel/".concat(id, "/Comment/").concat(snapshot.id), { id: snapshot.id });
                case 9:
                    _context3.next = 11;
                    return put({ type: actions.POST_CHAT_SUCCESS });
                case 11:
                    _context3.next = 17;
                    break;
                case 13:
                    _context3.prev = 13;
                    _context3.t0 = _context3["catch"](3);
                    _context3.next = 17;
                    return put({ type: actions.POST_CHAT_FAILURE, error: _context3.t0.message });
                case 17:
                case "end": return _context3.stop();
            }
    }, _marked3, null, [[3, 13]]);
}
function deleteChat(action) { var channelId, commentId, password, target; return _regeneratorRuntime().wrap(function deleteChat$(_context4) { while (1)
    switch (_context4.prev = _context4.next) {
        case 0:
            channelId = action.channelId, commentId = action.commentId, password = action.password;
            _context4.prev = 1;
            _context4.next = 4;
            return call(rsfDB.getDocument, firestore().collection('Channel').doc(channelId).collection('Comment').where('id', '==', commentId).where('password', '==', password).limit(1));
        case 4:
            target = _context4.sent;
            if (!(target.size > 0)) {
                _context4.next = 10;
                break;
            }
            _context4.next = 8;
            return call(rsfDB.updateDocument, "Channel/".concat(channelId, "/Comment/").concat(commentId), { isDeleted: true });
        case 8:
            _context4.next = 11;
            break;
        case 10: throw new Error('비밀번호가 틀렸습니다. 비밀번호를 다시 입력해주세요');
        case 11:
            _context4.next = 13;
            return put({ type: actions.DELETE_CHAT_SUCCESS });
        case 13:
            _context4.next = 19;
            break;
        case 15:
            _context4.prev = 15;
            _context4.t0 = _context4["catch"](1);
            _context4.next = 19;
            return put({ type: actions.DELETE_CHAT_FAILURE, error: _context4.t0.message });
        case 19:
        case "end": return _context4.stop();
    } }, _marked4, null, [[1, 15]]); }
function postObjectChat(action) {
    var id, target, data, snapshot;
    return _regeneratorRuntime().wrap(function postObjectChat$(_context5) {
        while (1)
            switch (_context5.prev = _context5.next) {
                case 0:
                    id = action.id, target = action.target, data = action.data; // 댓글 입력을 진행할 경우, 유저를 저장한다.
                    _context5.next = 3;
                    return put({ type: actions.SAVE_USER, name: data.name, password: data.password });
                case 3:
                    _context5.prev = 3;
                    _context5.next = 6;
                    return call(rsfDB.addDocument, "Channel/".concat(id, "/Object/").concat(target, "/Comment"), _objectSpread(_objectSpread({}, data), {}, { channelId: id, targetId: target, createdAt: firestore.FieldValue.serverTimestamp(), isDeleted: false }));
                case 6:
                    snapshot = _context5.sent;
                    _context5.next = 9;
                    return call(rsfDB.updateDocument, "Channel/".concat(id, "/Object/").concat(target, "/Comment/").concat(snapshot.id), { id: snapshot.id });
                case 9:
                    _context5.next = 11;
                    return call(rsfDB.updateDocument, "Exhibition/".concat(id, "/Paintings/").concat(target), { commentCount: firestore.FieldValue.increment(1) });
                case 11:
                    _context5.next = 13;
                    return put({ type: actions.POST_CHAT_SUCCESS });
                case 13:
                    _context5.next = 19;
                    break;
                case 15:
                    _context5.prev = 15;
                    _context5.t0 = _context5["catch"](3);
                    _context5.next = 19;
                    return put({ type: actions.POST_CHAT_FAILURE, error: _context5.t0.message });
                case 19:
                case "end": return _context5.stop();
            }
    }, _marked5, null, [[3, 15]]);
}
function deleteObjectChat(action) { var channelId, targetId, commentId, password, target; return _regeneratorRuntime().wrap(function deleteObjectChat$(_context6) { while (1)
    switch (_context6.prev = _context6.next) {
        case 0:
            channelId = action.channelId, targetId = action.targetId, commentId = action.commentId, password = action.password;
            _context6.prev = 1;
            _context6.next = 4;
            return call(rsfDB.getDocument, firestore().collection('Channel').doc(channelId).collection('Object').doc(targetId).collection('Comment').where('id', '==', commentId).where('password', '==', password).limit(1));
        case 4:
            target = _context6.sent;
            if (!(target.size > 0)) {
                _context6.next = 12;
                break;
            }
            _context6.next = 8;
            return call(rsfDB.updateDocument, "Channel/".concat(channelId, "/Object/").concat(targetId, "/Comment/").concat(commentId), { isDeleted: true });
        case 8:
            _context6.next = 10;
            return call(rsfDB.updateDocument, "Exhibition/".concat(channelId, "/Paintings/").concat(targetId), { commentCount: firestore.FieldValue.increment(-1) });
        case 10:
            _context6.next = 13;
            break;
        case 12: throw new Error('비밀번호가 틀렸습니다. 비밀번호를 다시 입력해주세요');
        case 13:
            _context6.next = 15;
            return put({ type: actions.DELETE_CHAT_SUCCESS });
        case 15:
            _context6.next = 21;
            break;
        case 17:
            _context6.prev = 17;
            _context6.t0 = _context6["catch"](1);
            _context6.next = 21;
            return put({ type: actions.DELETE_CHAT_FAILURE, error: _context6.t0.message });
        case 21:
        case "end": return _context6.stop();
    } }, _marked6, null, [[1, 17]]); }
function watchSyncNumberOfChat() { return _regeneratorRuntime().wrap(function watchSyncNumberOfChat$(_context7) { while (1)
    switch (_context7.prev = _context7.next) {
        case 0:
            _context7.next = 2;
            return takeEvery(actions.SYNC_NUMBER_OF_CHAT_REQUEST, syncNumberOfChat);
        case 2:
        case "end": return _context7.stop();
    } }, _marked7); }
function watchSyncNumberOfObjectChat() { return _regeneratorRuntime().wrap(function watchSyncNumberOfObjectChat$(_context8) { while (1)
    switch (_context8.prev = _context8.next) {
        case 0:
            _context8.next = 2;
            return takeEvery(actions.SYNC_NUMBER_OF_OBJECT_CHAT_REQUEST, syncNumberOfObjectChat);
        case 2:
        case "end": return _context8.stop();
    } }, _marked8); }
function watchPostChat() { return _regeneratorRuntime().wrap(function watchPostChat$(_context9) { while (1)
    switch (_context9.prev = _context9.next) {
        case 0:
            _context9.next = 2;
            return takeEvery(actions.POST_CHAT_REQUEST, postChat);
        case 2:
        case "end": return _context9.stop();
    } }, _marked9); }
function watchDeleteChat() { return _regeneratorRuntime().wrap(function watchDeleteChat$(_context10) { while (1)
    switch (_context10.prev = _context10.next) {
        case 0:
            _context10.next = 2;
            return takeEvery(actions.DELETE_CHAT_REQUEST, deleteChat);
        case 2:
        case "end": return _context10.stop();
    } }, _marked10); }
function watchPostObjectChat() { return _regeneratorRuntime().wrap(function watchPostObjectChat$(_context11) { while (1)
    switch (_context11.prev = _context11.next) {
        case 0:
            _context11.next = 2;
            return takeEvery(actions.POST_OBJECT_CHAT_REQUEST, postObjectChat);
        case 2:
        case "end": return _context11.stop();
    } }, _marked11); }
function watchDeleteObjectChat() { return _regeneratorRuntime().wrap(function watchDeleteObjectChat$(_context12) { while (1)
    switch (_context12.prev = _context12.next) {
        case 0:
            _context12.next = 2;
            return takeEvery(actions.DELETE_OBJECT_CHAT_REQUEST, deleteObjectChat);
        case 2:
        case "end": return _context12.stop();
    } }, _marked12); } // function* watchUpdateGlobalData() {
//   yield takeEvery<string>(actions.UPDATE_GLOBAL_DATA_REQUEST, updateGlobalData);
// }
export default function chatSaga() { return _regeneratorRuntime().wrap(function chatSaga$(_context13) { while (1)
    switch (_context13.prev = _context13.next) {
        case 0:
            _context13.next = 2;
            return all([fork(watchSyncNumberOfChat), fork(watchSyncNumberOfObjectChat), fork(watchPostChat), fork(watchDeleteChat), fork(watchPostObjectChat), fork(watchDeleteObjectChat)]);
        case 2:
        case "end": return _context13.stop();
    } }, _marked13); }
